import React, { Component } from "react";
import { Redirect } from "react-router";
import accountService from "../../../services/AccountService";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import Type from "../../Global/Typography.js";
import { isPasswordValid } from "../../Global/tools.js";

import NanoFlex from "./../../Global/NanoFlex.js";
import Loading from "./../../Nano/Loading.js";
import Input from "./../../Nano/Input.js";
import Button from "./../../Nano/Buttons/Button.js";

//Images
import backgroundImage from "../../../images/bck-login.svg";
import { ReactComponent as Warning } from "../../Global/Icons/warning.svg";
import { ReactComponent as Check } from "../../Global/Icons/check.svg";

const multiple = nota.global.multiple;

const StyledRecoverPassword = styled(NanoFlex)`
  height: 100vh;
  background-color: ${nota.color.main.default};
  background-image: url(${backgroundImage});
  background-repeat: no-repeat, repeat;
  background-size: cover;
  background-position: center;

  .containerInfo {
    background-color: ${nota.color.neutral.lightGrey};
    width: 350px;
    height: auto;
    padding: ${multiple * 6 + "px"}; /*24px*/
    .formWrapper {
      .formContainer {
        .form-wrapper {
          width: 100%;
          .passwordInvalid {
            height: auto;
            text-align: center;
            h6 {
              color: ${(props) => (props.passwordInvalid ? nota.color.main.mTwo : nota.color.neutral.NeuOne)};
            }
          }
          .buttonsWrapper {
            margin-top: 16px;
            .buttonWrapper {
              width: 100%;
              text-align: center;
            }
          }
        }
      }
    }
  }

  /* ERROR NOTIFICATION */
  .alertNotificationContainer {
    height: 32px;
    margin-top: ${multiple * 2 + "px"};
  }

  .alertNotificationWrapper {
    height: auto;
    width: 100%;

    .alertWrapper {
      padding: ${multiple + "px"};
      .iconWrapper {
        width: auto;
        margin: 0 ${multiple * 2 + "px"};
        svg {
          width: auto;
          height: 16px;
        }
      }
    }
  }
  .errorNotification {
    background-color: ${nota.color.main.mTwo};
    .iconWrapper {
      svg {
        path {
          fill: ${nota.color.neutral.white};
        }
      }
    }
    .notificationWrapper {
      p {
        color: ${nota.color.neutral.white};
      }
    }
  }

  /* NOTIFICATION */
  .wrapperNotification {
    .iconWrapper {
      padding: ${multiple * 3 + "px"};
      svg {
        height: 100px;
        width: auto;
      }
    }
    .infoNotification {
      text-align: center;
      padding: ${multiple * 8 + "px"} ${multiple * 3 + "px"};
      h3 {
        color: ${nota.color.neutral.NeuOne};
        text-transform: uppercase;
        font-weight: bold;
      }
    }
  }

  @media only screen and (max-width: 374px) {
    .containerInfo {
      width: 75%;
      width: 272px;
      padding: 48px 24px;
      .wrapperNotification {
        .infoNotification {
          padding: 64px 8px;
        }
      }
    }
  }
`;

const StyledLoading = styled(NanoFlex)`
  height: 100vh;
`;

export class RecoverPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      recoverPasswordStatus: null,

      newPassword: "",
      newPasswordError: false,
      repeatNewPassword: "",
      repeatNewPasswordError: false,
      passwordsNotMatching: false,
      passwordInvalid: false,
    };
  }

  componentDidMount() {
    this.getRecoverPasswordStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.redirectToLogin) this.setState({ redirectToLogin: false });
  }

  getRecoverPasswordStatus = () => {
    accountService
      .canRecoverPassword(this.props.match.params.hash)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ recoverPasswordStatus: data ? null : false, loading: false });
      });
  };

  onNewPasswordChange = (val) => {
    this.setState({ newPassword: val });
  };

  onRepeatNewPasswordChange = (val) => {
    this.setState({ repeatNewPassword: val });
  };

  recoverPasswordSubmit = (event) => {
    let canRecoverPassword = true;
    // Prevent page refresh
    event.preventDefault();
    if (!this.state.newPassword || this.state.newPassword.trim() == "") {
      canRecoverPassword = false;
      this.setState({ newPasswordError: true });
    } else {
      this.setState({ newPasswordError: false });
    }

    if (!this.state.repeatNewPassword || this.state.repeatNewPassword.trim() == "") {
      canRecoverPassword = false;
      this.setState({ repeatNewPasswordError: true });
    } else {
      this.setState({ repeatNewPasswordError: false });
    }

    if (canRecoverPassword && this.state.newPassword !== this.state.repeatNewPassword) {
      canRecoverPassword = false;
      this.setState({ passwordsNotMatching: true, newPasswordError: true, repeatNewPasswordError: true });
    } else {
      this.setState({ passwordsNotMatching: false });
    }

    if (!isPasswordValid(this.state.newPassword)) {
      canRecoverPassword = false;
      this.setState({ passwordInvalid: true });
    } else {
      this.setState({ passwordInvalid: false });
    }

    if (canRecoverPassword) {
      accountService
        .useRecoverPassword({ hash: this.props.match.params.hash, newPassword: this.state.newPassword })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ recoverPasswordStatus: data ? true : false });
        });
    }
  };

  redirectToLogin = () => {
    this.setState({ redirectToLogin: true });
  };

  render() {
    if (this.state.redirectToLogin) return <Redirect to="/login" />;
    if (this.state.loading) {
      return (
        <StyledLoading className="loadingContainer">
          <Loading />
        </StyledLoading>
      );
    }

    return (
      <StyledRecoverPassword passwordInvalid={this.state.passwordInvalid}>
        <NanoFlex className="containerInfo">
          {this.state.recoverPasswordStatus === false && (
            // <div>Invalid Recovery Password</div>
            <NanoFlex className="wrapperNotification" flexDirection="column">
              <NanoFlex className="iconWrapper">
                <Warning />
              </NanoFlex>

              <NanoFlex className="infoNotification">
                <Type.h3>This link is no longer available!</Type.h3>
              </NanoFlex>
              <NanoFlex className="buttonsWrapper" flexDirection="column">
                <Button id={1} label={"Back to Login"} type={"button"} simple clickAction={this.redirectToLogin} />
              </NanoFlex>
            </NanoFlex>
          )}

          {this.state.recoverPasswordStatus === null && (
            <NanoFlex className="formWrapper" flexDirection="column">
              <NanoFlex className="titleForm" justifyContent="flex-start" alignItems="flex-start">
                <Type.h2>
                  Reset <b>NOTA</b> Password
                </Type.h2>
              </NanoFlex>

              <NanoFlex className="formContainer">
                <form className="form-wrapper" onSubmit={this.recoverPasswordSubmit}>
                  <NanoFlex className="alertNotificationContainer">
                    {this.state.passwordsNotMatching && (
                      <NanoFlex className="alertNotificationWrapper errorNotification">
                        <NanoFlex className="alertWrapper">
                          <NanoFlex className="iconWrapper">
                            <Warning />
                          </NanoFlex>
                          <NanoFlex className="notificationWrapper" justifyContent={"flex-start"} alignContent={"flex-start"}>
                            <Type.p>Passwords do not match</Type.p>
                          </NanoFlex>
                        </NanoFlex>
                      </NanoFlex>
                    )}
                  </NanoFlex>

                  <Input title="Password" placeholder="Password" defaultValue={this.state.newPassword} eye={true} error={this.state.newPasswordError} onChangeAction={this.onNewPasswordChange} />
                  <Input title="Repeat Password" placeholder="Repeat Password" defaultValue={this.state.repeatNewPassword} eye={true} error={this.state.repeatNewPasswordError} onChangeAction={this.onRepeatNewPasswordChange} />

                  <NanoFlex className="passwordInvalid">
                    <Type.h6>Password must contain a minimum of 6 alphanumeric characters, including at least one upper case letter & one number.</Type.h6>
                  </NanoFlex>

                  <NanoFlex className="buttonsWrapper" flexDirection="column">
                    <Button label={"Confirm"} type={"submit"} />
                    <Button id={1} label={"Back to Login"} type={"button"} simple clickAction={this.redirectToLogin} />
                  </NanoFlex>
                </form>
              </NanoFlex>
            </NanoFlex>
          )}

          {this.state.recoverPasswordStatus === true && (
            <NanoFlex className="wrapperNotification" flexDirection="column">
              <NanoFlex className="iconWrapper">
                <Check />
              </NanoFlex>

              <NanoFlex className="infoNotification">
                <Type.h3>Password changed successfully!</Type.h3>
              </NanoFlex>
              <NanoFlex className="buttonsWrapper" flexDirection="column">
                <Button id={1} label={"Back to Login"} type={"button"} simple clickAction={this.redirectToLogin} />
              </NanoFlex>
            </NanoFlex>
          )}
        </NanoFlex>
      </StyledRecoverPassword>
    );
  }
}
